import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import {
  fetchRoleFromJwt,
  getAuthToken,
  isAuthTokenValid,
} from "../commons/AuthTokenUtils";

export const AdminProtectedRoute = (props: {
  children: ReactElement;
}): ReactElement => {
  let authToken = getAuthToken();
  if (!authToken || !isAuthTokenValid()) {
    return <Navigate to="/user/login" />;
  }

  let role = fetchRoleFromJwt(authToken);
  if (role !== "admin") {
    return <Navigate to="/" />;
  }

  return props.children;
};
